"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleReliablePartnerPdfStatusEvents = void 0;
const rxjs_1 = require("rxjs");
const TenderActions = require("../../../actions/bid/tender");
const eventTypes = require("../eventTypes");
const utils_1 = require("../utils");
const operators_1 = require("rxjs/operators");
const handleSuccess = (action) => (0, utils_1.validate)(action.payload, eventTypes.iReliablePartnerPdfStatusSuccessEvent, () => {
    const event = action.payload;
    return (0, rxjs_1.of)(TenderActions.updateReliablePartnerPdfStatusSuccess({
        participantUuid: event.message.participantUuid
    }));
});
const handleFailure = (error) => {
    if (typeof error === 'string') {
        console.error(error);
        return rxjs_1.EMPTY;
    }
    return (0, utils_1.validate)(error.payload, eventTypes.iReliablePartnerPdfStatusFailedEvent, () => (0, rxjs_1.of)(TenderActions.updateReliablePartnerPdfStatusFailure({
        error: error.payload.message.error,
        participantUuid: error.payload.message.participantUuid
    })));
};
const handleReliablePartnerPdfStatusEvents = (action$) => action$.payload.event === eventTypes.GENERATE_REPORT_STATUS_SUCCESS
    ? handleSuccess(action$).pipe((0, operators_1.catchError)((error) => handleFailure(error)))
    : handleFailure(action$).pipe((0, operators_1.catchError)((error) => handleFailure(error)));
exports.handleReliablePartnerPdfStatusEvents = handleReliablePartnerPdfStatusEvents;
//# sourceMappingURL=reliablePartnerPdfStatus.js.map